'use strict';

exports.__esModule = true;
exports.initializeFedops = initializeFedops;
exports.initializeApp = initializeApp;
exports.initializeGlobal = initializeGlobal;
exports.getLoadStartTime = getLoadStartTime;
exports.setLoadStartTime = setLoadStartTime;
exports.setSessionId = setSessionId;

var _env = require('../env');

function getAppData(appName) {
  return (((0, _env.env)().fedops || {}).apps || {})[appName];
}

function initializeFedops() {
  (0, _env.env)().fedops = (0, _env.env)().fedops || {};
  (0, _env.env)().fedops.apps = (0, _env.env)().fedops.apps || {};
}

function initializeApp(appName) {
  (0, _env.env)().fedops.apps[appName] = (0, _env.env)().fedops.apps[appName] || {};
}

function initializeGlobal(appName) {
  initializeFedops();
  initializeApp(appName);
}

function getLoadStartTime(appName) {
  return (getAppData(appName) || {}).startLoadTime || 0;
}

function setLoadStartTime(appName, startLoadTime) {
  return (getAppData(appName) || {}).startLoadTime = startLoadTime;
}

function setSessionId(sessionId) {
  return ((0, _env.env)().fedops || {}).sessionId = sessionId;
}